import { Color } from 'lib/components/types';
import React from 'react';
import classes from './index.module.scss';

/**
 * Input interface extending HTML input attributes
 */
interface Input extends React.InputHTMLAttributes<HTMLInputElement> {}

/**
 * Props interface for the Switch component
 */
interface Props extends Omit<Input, 'value' | 'checked' | 'onChange' | 'className' | 'type'> {
	/** Color theme for the switch */
	color?: Color | 'primary2';
	/** Whether the switch is checked/on */
	checked: boolean;
	/** Callback function when the switch state changes */
	handleChecked: (value: boolean) => void;
}

/**
 * Switch component
 * Renders a toggle switch with customizable color
 * Used for boolean settings and options
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const Switch = ({ id, color = 'primary', checked, handleChecked, ...props }: Props) => {
	// Apply color styling based on the color prop
	const colorClassName = color ? classes[`switch-color-${color}`] : '';
	// Combine base class with color class
	const combinedClassName = `${classes['switch-label']} ${colorClassName}`;

	return (
		<>
			{/* Hidden checkbox input that maintains the checked state */}
			<input
				id={id}
				type="checkbox"
				checked={checked}
				onChange={(e) => handleChecked(e.target.checked)}
				className={classes['switch-checkbox']}
				{...props}
			/>
			{/* Visible switch label that styles the toggle */}
			<label className={combinedClassName} htmlFor={id}>
				<span className={classes['switch-button']} />
			</label>
		</>
	);
};

export default Switch;
